import { cn } from '@/lib/utils';

interface OnboardingContinueButtonProps {
  onClick: () => void;
  className?: string;
  label?: string;
}

export function OnboardingContinueButton({
  onClick,
  className,
  label = 'Continue',
}: OnboardingContinueButtonProps) {
  return (
    <button
      type="button"
      data-slot="onboarding-continue"
      onClick={onClick}
      className={cn(
        'flex h-[52px] w-full items-center justify-center rounded-full bg-mf-neutral-900 px-5 font-body text-base font-bold text-white transition-opacity hover:opacity-90',
        className,
      )}
    >
      {label}
    </button>
  );
}
